/**
 * ICP (Intercompany) code utilities.
 *
 * ICP codes follow the format ICP_{{code}} (e.g. ICP_1421, ICP_EntityA).
 * Codes without ICP_ prefix, empty, or "-" are not intercompany.
 */

/**
 * Return true if the code represents an intercompany partner (ICP_* format).
 *
 * - ICP_1421, ICP_EntityA -> true (intercompany)
 * - null, undefined, "", "-", or no ICP_ prefix -> false (not intercompany)
 */
export function isIcpCode(code: string | null | undefined): boolean {
  if (!code?.trim()) return false;
  const c = code.trim();
  return c !== '-' && c.toUpperCase().startsWith('ICP_');
}
